import { render, staticRenderFns } from "./SBUserPlan.html?vue&type=template&id=ab41c070&scoped=true&"
import script from "./SBUserPlan.ts?vue&type=script&lang=ts&"
export * from "./SBUserPlan.ts?vue&type=script&lang=ts&"
import style0 from "./SBUserPlan.css?vue&type=style&index=0&id=ab41c070&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab41c070",
  null
  
)

export default component.exports